module.exports = __webpack_public_path__ + "a772d969e27a54dbf39bd62c4355e308.png";